// eslint-disable-next-line
import React, { Component } from 'react';
import { CalendarSession } from './CalendarSession';

export class CalendarDay extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isToday: this.props.today.IsSameDate(this.props.date),
            isWeekend: this.props.date.DayOfWeek === 'Saturday' || this.props.date.DayOfWeek === 'Sunday'
        };
    }

    onClick(date, text, selected, code) {
        this.props.onClick(date, text, selected, code);
    }

    render() {
        let { today, date, slots, sessions, activities } = this.props;

        let color = this.state.isToday
            ? '#FFA5AD'
            : this.state.isWeekend
                ? '#93FF93'
                : date.DayOfWeek === 'Tuesday' || date.DayOfWeek === 'Thursday'
                    ? '#DDD'
                    : 'primary';

        return (
            <tr style={{ 'background': color }}>
                <td>
                    <span
                        style={{ 'textAlign': 'center', 'verticalAlign': 'middle' }}>
                        {date.Day}  &nbsp;  &nbsp;
                        {date.DayOfWeekShort}
                    </span>
                </td>
                {sessions.map((session, k) =>
                    <td key={k}>
                        <CalendarSession
                            key={k}
                            today={today}
                            date={date}
                            onClick={this.onClick.bind(this)}
                            text={session}
                            slots={slots}
                            activities={activities} />
                    </td>)}
            </tr>
        );
    }
}